import { DocumentOrderUIStatus } from '../enums/index';

/**
 * Get order status message for the placed order
 * @param { customStatus }
 * @returns
 */

export const getOrderStatusClass = (customStatus: string) => {
  switch (customStatus) {
    case DocumentOrderUIStatus.Request:
      return 'chip status-pending';
    case DocumentOrderUIStatus.Pending:
      return 'chip status-pending';
    case DocumentOrderUIStatus.Failed:
      return 'chip status-error';
    case DocumentOrderUIStatus.Success:
      return 'chip status-complete';
    default:
      return '';
  }
};
